import Request from "../config/Request";
import axios from 'axios'; 


const identify = async (data) => {
    return Request.post('https://apis.ffeleven.com/api/web_portal/identify', data)
}

const verify = async (data) => {
    return Request.post('https://apis.ffeleven.com/api/web_portal/verify', data)
}


export {
    identify,
    verify,
}
